import { useContext, useState, useRef, useEffect, Fragment } from 'react';
import { GlobalMobileContext } from '../../contexts/globalMobileContext';
import "./pages.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import styles from './Mobile_ConferenceNotesPage.module.css'

import { sortNotesByUpdatedAt } from '../../utils/UtilitaryFunctions';

const Mobile_ConferenceNotesPage = () => {
    const { mobileSocketRef, currentNotesList, setCurrentNotesList, currentConference, setCurrentError, typeParam, setTypeParam, currentUser, setCurrentPage, setCurrentNote } = useContext(GlobalMobileContext);
    const [selectedEntity, setSelectedEntity] = useState(null);

    const startX = useRef(0);
    const startY = useRef(0);
    const isDragging = useRef(false);
    const draggedElement = useRef(null);

    const [draggedNoteId, setDraggedNoteId] = useState(null);


    useEffect(() => {
        if (typeParam === "notes") {
            setTypeParam(null)
        }
    }, [])

    const deleteEntity = (entity) => {
        mobileSocketRef.current.emit("MOBILE_CONFERENCE_DELETE_NOTE", entity._id, (callback) => {
            if (!callback.error) {

                let notes = sortNotesByUpdatedAt(callback.response)
                setCurrentNotesList(notes)

                setSelectedEntity(null);
            } else {
                setCurrentError(callback.error)
            }


        });

    }

    const openNoteEdit = (note) => {
        setCurrentPage("NotesEdit")
        setCurrentNote(note)
    }

    const handlePointerDown = (e) => {
        startX.current = e.clientX
        startY.current = e.clientY;
        draggedElement.current = e.currentTarget;
        draggedElement.current.setPointerCapture(e.pointerId);

        draggedElement.current.style.transition = 'none';

        e.currentTarget.setPointerCapture(e.pointerId);
    };

    const handlePointerMove = (e) => {
        if (!draggedElement.current) return;

        const deltaX = e.clientX - startX.current;
        const deltaY = e.clientY - startY.current;

        if (!isDragging.current && Math.abs(deltaX) > Math.abs(deltaY) && deltaX < 0) {
            isDragging.current = true;
            setDraggedNoteId(draggedElement.current.id)
        }

        if (isDragging.current) {
            e.preventDefault();
            if (deltaX > 0) {
                draggedElement.current.style.transform = `translateX(0px)`;
            } else if (deltaX < -60) {
                draggedElement.current.style.transform = `translateX(-60px)`;
            } else {
                draggedElement.current.style.transform = `translateX(${deltaX}px)`;
            }

        }
    };

    const handlePointerUp = (e, entity) => {
        if (!draggedElement.current) return;

        const deltaX = e.clientX - startX.current;

        draggedElement.current.releasePointerCapture(e.pointerId);

        if (isDragging.current) {
            if (deltaX < -30) {
                setSelectedEntity(entity)
            } else {
                draggedElement.current.style.transition = 'transform 0.2s ease-out';
                draggedElement.current.style.transform = 'translateX(0)';
                setTimeout(() => {
                    if (draggedElement.current) {
                        draggedElement.current.style.transition = '';
                    }
                }, 200);
            }
        }

        isDragging.current = false;
        draggedElement.current = null;
        setDraggedNoteId(null);
    };



    return (
        <>
            <div className={styles.pagetitle}>
                <h1 className={styles.title}>Notes</h1>
                <h1 className={styles.bigTitleName}>{currentConference.name}</h1>
            </div>

            <section className={styles.sectionScroll} >
                <div className={styles.row} >
                    <div>
                        {currentNotesList && currentNotesList.map((entity, i) => (<Fragment key={entity._id}>
                            {(i === 0 || entity.timeCategory !== currentNotesList[i - 1].timeCategory) && <div>{entity.timeCategory}</div>}
                            <div className={styles.cardNotes} onClick={() => openNoteEdit(entity)}
                            // onPointerDown={(e) => handlePointerDown(e)}
                            // onPointerMove={handlePointerMove}
                            // onPointerUp={(e) => handlePointerUp(e, entity)}
                            >
                                <div style={{ maxWidth: "90%" }} >{entity.text}</div>
                                <FontAwesomeIcon className="icon-more" icon={byPrefixAndName.fal["trash"]} style={{ position: "relative" }} onClick={(e) => {
                                    e.stopPropagation()
                                    deleteEntity(entity._id)
                                }} />
                            </div>

                        </Fragment>))}

                    </div>
                </div>
                <div className={styles.topShadow} />
                <div className={styles.bottomShadow} />
            </section>

            <div className={styles.addNotesButton} onClick={() => openNoteEdit(null)}>
                <FontAwesomeIcon icon={byPrefixAndName.fal["add"]} />
            </div>

        </>
    );
}

export default Mobile_ConferenceNotesPage;
